import { render, staticRenderFns } from "./EducationItem.vue?vue&type=template&id=e488b4a2&scoped=true"
import script from "./EducationItem.vue?vue&type=script&lang=js"
export * from "./EducationItem.vue?vue&type=script&lang=js"
import style0 from "./EducationItem.vue?vue&type=style&index=0&id=e488b4a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e488b4a2",
  null
  
)

export default component.exports